<template>
  <div id="modal" class="modal estimate_modal parent_div" v-show="modalShown">
    <div class="modal-main wrapper" id="estimate_main">
      <div class="estimate_area">
        <div class="estimate_title">
          <h2>{{estimateTitle}}</h2>
        </div>
        <div class="estimate_info">
          <template v-if="isProductData">
            <section id="color">
              <h2 class="title">カラー</h2>
              <ul id="color_list">
                <li v-if="colorDoor">
                  <dd-color
                    :title="titleDoor"
                    :color="colorDoor"
                  />
                </li>
                <li v-if="colorCabine">
                  <dd-color
                    :title="titleCabine"
                    :color="colorCabine"
                  />
                </li>
                <li v-if="colorCounter">
                  <dd-color
                    :title="titleCounter"
                    :color="colorCounter"
                  />
                </li>
              </ul>
            </section>
            <section class="estimation">
              <h2 class="title">商品 見積り</h2>
              <div id="est_title">{{fileName}}</div>
              <dd-price
                :priceData="priceData"
                :dcProductCount="dcProductCount"
                :isCalcDelivery="isCalcDelivery"
                :isProfitFlag="isProfitFlag"
              />
              <div v-if="resrchFlag">
                <h2 class="title">事前調査費 見積り</h2>
                <div id="est_title">{{fileName}}</div>
                <dd-resrch-price
                  :priceData="priceData"
                />
              </div>
              <div class="maker-corp middle_text bold" v-if="corpData && corpData.corpName">
                <div>製造会社</div>
                <div>この商品は、{{corpData.corpName}}が製造し、発送します。</div>
                <div class="maker_info">
                  <ul>
                    <li>{{corpData.corpName}}</li>
                    <li>〒{{corpData.postcd}}</li>
                    <li>{{corpData.state}}{{corpData.city}}{{corpData.street}}{{corpData.branch}}</li>
                    <li>TEL.{{corpData.tel}}</li>
                    <li>FAX.{{corpData.fax}}</li>
                    <li class="caution">※自動メールにて返信しますので{{mailTo}}からのメールを受信許可に設定してください。</li>
                  </ul>
                </div>
              </div>
            </section>
          </template>
        </div>
        <div class="corp_info_area">
          <div class="corp_logo">
            <img :src="getImage('common/domanslogo_copyright.svg')" />
          </div>
          <div id="logo">
            <img :src="this.getImage('common/mmstylelogo_catch.svg')" />
          </div>
        </div>
      </div>
      <section v-if="isDrawing" id="noinfo_sheet" class="print_view page-always" >
        <h2 class="title" id="title">図面</h2>
        <dd-sheet
          ref="sheetModalRef"
          :spaceJoincd="spaceJoincd"
          :isPreview=false
          :svgWidth="svgWidth"
          :svgHeight="svgHeight"
          @showModal="delayShowModal"
        />
        <div class="corp_info_area">
          <div class="corp_logo">
            <img :src="getImage('common/domanslogo_copyright.svg')" />
          </div>
          <div id="logo">
            <img :src="this.getImage('common/mmstylelogo_catch.svg')" />
          </div>
        </div>
      </section>
      <div class="button-area">
        <div class="cancel-btn-area">
          <!-- <button type="button" class="main_btn sel_sub_btn" @click="onCancel()">キャンセル</button> -->
          <div class="main_btn sel_sub_btn" @click="onCancel()">
            <a>
              <label>キャンセル</label>
            </a>
          </div>
        </div>
        <div class="success-btn-area">
          <div class="main_btn act_sub_btn" @click="preview()" v-if="isDrawing" v-on:mouseover="isOnPreview(true)" v-on:mouseleave="isOnPreview(false)">
            <img :src="imgPreview" class="icon">
            <a>
              <label>プレビュー</label>
            </a>
          </div>
          <div class="main_btn act_sub_btn" @click="print()" v-on:mouseover="isOnPrint(true)" v-on:mouseleave="isOnPrint(false)">
            <img :src="imgPrint" class="icon">
            <a>
              <label>印刷</label>
            </a>
          </div>
          <div class="main_btn sel_main_btn" @click="onOrder()" v-if="dispOrderButton" v-on:mouseover="isOnCart(true)" v-on:mouseleave="isOnCart(false)">
            <img :src="imgCart" class="icon">
            <a>{{orderTitle}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as App from '../../../../../utils/App'
import * as AppEc from '../../../../utils/AppEc'
import * as Check from '../../../../../utils/Check'

import PriceList from '../../../payment/PriceList'
import PriceResrchList from '../../../payment/ResrchPrice'
import Color from '../color/DcColor'
import Sheet from './EstimateSheet'

export default {
  name: 'estimateModal',
  components: {
    'dd-color': Color,
    'dd-price': PriceList,
    'dd-sheet': Sheet,
    'dd-resrch-price': PriceResrchList
  },
  props: {
    /** OK押下時コールバック */
    onOk: {
      type: Function,
      default: function () {}
    },
    /** コールバックに渡す引数 */
    callbackParams: {
      type: Object,
      default: function () { return {} }
    },
    showSuccess: {
      type: Function,
      default: function () {}
    },
    fileName: {
      type: String,
      default: ''
    },
    titleDoor: {
      type: String
    },
    colorDoor: {
      type: Object
    },
    titleCabine: {
      type: String
    },
    colorCabine: {
      type: Object
    },
    titleCounter: {
      type: String
    },
    colorCounter: {
      type: Object
    },
    fileData: {
      type: Object
    },
    priceData: {
      type: Object
    },
    spaceJoincd: String,
    dispOrderButton: {
      type: Boolean,
      default: true
    },
    dcProductCount: Number,
    isCalcDelivery: Boolean,
    resrchFlag: {
      type: Boolean,
      default: false
    },
    isDrawing: Boolean,
    corpData: {
      type: Object,
      default: undefined
    },
    isProfitFlag: {
      type: Boolean,
      default: false
    },
    isProductData: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      svgWidth: '100%',
      svgHeight: '100%',
      imgPreview: this.getImage('common/preview_black.svg'),
      imgPrint: this.getImage('common/print_black.svg'),
      imgCart: this.getImage('common/cart_white.svg')
    }
  },
  watch: {
  },
  computed: {
    estimateTitle: function () {
      if (this.resrchFlag) {
        return '事前現場調査 お見積り'
      } else if (this.isDrawing) {
        return 'mm/style 図面 見積り'
      } else {
        return 'mm/style 見積り'
      }
    },
    orderTitle: function () {
      if (this.resrchFlag) {
        return '注文する'
      } else {
        return 'カートに追加'
      }
    },
    mailTo: function () {
      return '「@domans.co.jp」、「@candeal.co.jp」'
    }
  },
  methods: {
    showModal: function () {
    },
    delayShowModal: function () {
      this.showSuccess(this.callbackParams)
      // 図面が完成してから表示
      this.modalShown = true
      this.$nextTick(function () {
        if (!Check.isBrawserIE()) return
        let modalWidth = document.getElementById('estimate_main').clientWidth
        let modalHeight = document.getElementById('estimate_main').clientHeight
        // 親領域のpadding、右のスクロールバーを引く
        this.svgWidth = (modalWidth - 20 - 20) + 'px'
        this.svgHeight = modalHeight * 0.6 + 'px'
      })
    },
    onCancel: function () {
      this.modalShown = false
    },
    onOrder: function () {
      if (!this.modalShown) return
      this.onOk(this.callbackParams)
      this.modalShown = false
    },
    handleScroll: function (event) {
      event.preventDefault()
    },
    preview: function () {
      let modalData = {
        svgWidth: '90%',
        spaceJoincd: this.spaceJoincd,
        isShowInfo: true
      }
      AppEc.showPreview(modalData)
    },
    print: function () {
      window.print()
    },
    isOnPreview: function (on) {
      if (on) {
        this.imgPreview = this.getImage('common/preview_white.svg')
      } else {
        this.imgPreview = this.getImage('common/preview_black.svg')
      }
    },
    isOnPrint: function (on) {
      if (on) {
        this.imgPrint = this.getImage('common/print_white.svg')
      } else {
        this.imgPrint = this.getImage('common/print_black.svg')
      }
    },
    isOnCart: function (on) {
      if (on) {
        this.imgCart = this.getImage('common/cart_red.svg')
      } else {
        this.imgCart = this.getImage('common/cart_white.svg')
      }
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  }, // end method
  mounted: function () {
  },
  created: function () {
    if (!this.isDrawing) this.delayShowModal()
  }
}
</script>
<style src="../../../../css/dcstyle.scss" lang="scss" scoped></style>
<style src="../../../../css/dc-order.scss" lang="scss" scoped></style>
<style src="../../../../css/print.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/top/input/estimate/EstimateModal.vue